pendingOrReceived